/* eslint-disable class-methods-use-this */
import { Injectable } from '@angular/core';
import { CONTEXT_HELP } from '../../constants/context-help';

interface ContextHelpOption {
  title: string;
  type: string;
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContextHelpService {
  private stateToResourceMap = {
    'app.account.connections': { resource: 'Connection', action: 'index' },
    'app.account.connections.new': { resource: 'Connection', action: 'new' },
    'app.account.package': { resource: 'Package', action: 'edit' },
    'app.account.packages': { resource: 'Package', action: 'index' },
    'app.account.clusters': { resource: 'Cluster', action: 'index' },
    'app.account.clusters.item': { resource: 'Cluster', action: 'show' },
    'app.account.schedules': { resource: 'Schedule', action: 'index' },
    'app.account.schedules.item': { resource: 'Schedule', action: 'show' },
    'app.account.settings.account.members': { resource: 'Member', action: 'index' },
    'app.account.settings.account.plans': { resource: 'Plan', action: 'edit' },
    'app.account.settings.account.info': { resource: 'Account', action: 'edit' },
    'app.account.settings.account.hooks': { resource: 'Hook', action: 'index' },
    'app.account.settings.my.notifications': { resource: 'Notification', action: 'show' },
    'app.account.settings.my.password': { resource: 'User', action: 'edit_password' },
    'app.account.settings.my.info': { resource: 'User', action: 'edit' },
    'app.account.settings.developer.tokens': { resource: 'User', action: 'edit' },
  };

  public getHelpForState(state: string): ContextHelpOption[] {
    const help = this.stateToResourceMap[state];
    if (help) {
      return ContextHelpService.getHelpForResource(help.resource, help.action);
    }
    return [];
  }

  private static getHelpForResource(resource: string, action: string): ContextHelpOption[] {
    return CONTEXT_HELP[resource][action];
  }
}
